<template>
  <Form
    ref="passwordForm"
    class="form-flex middle"
    label-position="left"
    :label-width="90"
    :model="passwordForm"
    :rules="rules"
    @submit.native.prevent
  >
    <BaseInput
      v-if="changePassword"
      v-model="passwordForm.oldPassword"
      label="舊密碼"
      prop="oldPassword"
      type="password"
      placeholder="請輸入您目前的密碼"
    />
    <BaseInput
      v-model="passwordForm.password"
      label="新密碼"
      prop="password"
      type="password"
      placeholder="僅可輸入8至16個英文字母或數字"
    />
    <BaseInput
      v-model="passwordForm.passwordCheck"
      label="新密碼確認"
      prop="passwordCheck"
      type="password"
      placeholder="請再次輸入密碼"
    />
  </Form>
</template>

<script>
  import { Form } from 'iview';
  import BaseInput from '@/components/forms/elements/BaseInput';
  import { password } from '@/utils/asyncValidator/rules';
  
  export default {
    components: { Form, BaseInput },
    props: {
      model: {
        type: Object,
        default: null
      },
      changePassword: {
        type: Boolean,
        default: false
      }
    },
    data() {
      // rules defined here for get "this" execution context
      const validatePassword = (rule, value, callback) => {
        if (!value) return callback(new Error('請輸入新密碼'));
        if (!/^\w*$/.test(value)) return callback(new Error('密碼不得含有空白或非英數字元'));
        if (value.length < 8 || value.length > 15) return callback(new Error('您的密碼長度需為 8 - 16 位數'));
        const { passwordCheck } = this.passwordForm;
        if (passwordCheck !== '') {
          this.$refs.passwordForm.validateField('passwordCheck');
        }
        callback();
      };

      const passwordCheck = (rule, value, callback) => {
        const { password } = this.passwordForm;
        if (password && !value) return callback(new Error('請再次確認您的密碼'));
        const isEqual = password === value;
        if (value && !isEqual) return callback(new Error('密碼不相符'));
        callback();
      };

      const rules = {
        oldPassword: password,
        password: [{ required: true, validator: validatePassword, trigger: 'blur' }],
        passwordCheck: [{ required: true, validator: passwordCheck, trigger: 'blur' }]
      };

      return {
        passwordForm: { ...this.model },
        rules
      };
    },
    methods: {
      validate() {
        return this.$refs.passwordForm.validate(valid => valid);
      },
      async getPayload() {
        const isValid = await this.validate();
        if (!isValid) return;
        return { ...this.passwordForm };
      },
      handleReset() {
        return this.$refs.passwordForm.resetFields();
      }
    }
  };
</script>
